export enum SituacaoDaCompraComCartaoDeCredito {
  Ativo = 'Ativo',
  Inativo = 'Inativo'
}
